import React from "react";
import { Row, Col, Card } from "reactstrap";
import { Sparklines, SparklinesCurve } from "react-sparklines";
import CountUp from "react-countup";

const IncomeTransition = ({ setFinantialRatio, data, setIsFirst }) => {
  const annualData = data && data.allAnnualData && data.allAnnualData.edges;

  return (
    <div>
      <div>
        <Row>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.memberFee.replace(/,/g, ""))
                  )
                );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-success"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">会費</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.memberFee.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.memberFee.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.donation.replace(/,/g, ""))
                  )
                );

                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-primary"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">寄付金</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.donation.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.donation.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.businessRevenue.replace(/,/g, ""))
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard  pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">自主事業</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.businessRevenue.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.businessRevenue.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.trusteeRevenue.replace(/,/g, ""))
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard  pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">受託事業</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.trusteeRevenue.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.trusteeRevenue.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.subsidy.replace(/,/g, ""))
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">助成金</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.subsidy.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.subsidy.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.bounty.replace(/,/g, ""))
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">補助金</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.bounty.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.bounty.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  annualData.map((array) =>
                    parseInt(array.node.miscellaneous.replace(/,/g, ""))
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content transitionCard pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">その他収益</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="countNum"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={parseInt(
                              annualData.slice(-1)[0] &&
                                annualData
                                  .slice(-1)[0]
                                  .node.miscellaneous.replace(/,/g, "")
                            )}
                            separator=","
                            // decimals={2}
                            // decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={annualData.map((array) =>
                        parseInt(array.node.miscellaneous.replace(/,/g, ""))
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default IncomeTransition;
